// Podpowiedzi wyszukiwarki magazynu: dokłada posty autora (metafield custom.author_name) do wyników /search/suggest.json,
// bo Shopify nie przeszukuje metafieldów. Najpierw trafienia frazy, potem posty autora, bez duplikatów.
// Używane w magazyn-nowy-hero, magazyn-nowy-tag-filter i main-search.
(function () {
  if (window.nikalabWithAuthorArticles) return;

  var cache = {};

  function fetchAuthorArticles(query) {
    if (!cache[query]) {
      var url = '/search?q=' + encodeURIComponent(query) + '&type=article&section_id=search-author-suggest';
      cache[query] = fetch(url)
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.map.call(doc.querySelectorAll('[data-author-articles] > li'), function (li) {
            return { url: li.dataset.url, title: li.dataset.title, image: li.dataset.image || null };
          });
        })
        .catch(function () { return []; });
    }
    return cache[query];
  }

  window.nikalabWithAuthorArticles = function (query, posts, limit) {
    posts = posts || [];
    limit = limit || 4;
    return fetchAuthorArticles(query).then(function (authorPosts) {
      var seen = {};
      return posts.concat(authorPosts).filter(function (post) {
        var key = String(post.url).split('?')[0];
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      }).slice(0, limit);
    });
  };
})();
